import { Route } from '@angular/router';

import { Api } from '../../../../../shared/constants/api';
import { RequiredSecurities } from '../../../../../shared/constants/required-securities';
import { FeatureFlagName } from '../../../../../shared/interfaces/feature-flag.interface';
import { ActivatedRouteData } from '../../../shared/constants';
import { AuthGuard } from '../../../services/auth/guards/auth.guard';
import { DigitalPropertyGuard } from '../../../services/auth/guards/digital-property.guard';
import { SecurityGuard } from '../../../services/auth/guards/security.guard';
import { FmeFeatureFlagGuard } from '../../../services/feature-management/fme-feature-flag.guard';

/**
 * Client-facing "Mobile manual evaluations" page of Expert Audits (digital property context): the list at
 * `/mobile-manual-evaluations` and the read-only detail at `/mobile-manual-evaluations/:id`. Needs the Read security
 * and the `mobile_manual_evaluations` FME flag.
 */
export const mobileManualEvaluationsRoute: Route = {
  path: `${Api.mobile_manual_evaluations}`,
  loadChildren: (): any => import('./mobile-manual-evaluations.module').then((m: any) => m.MobileManualEvaluationsModule),
  canActivate: [AuthGuard, DigitalPropertyGuard, SecurityGuard, FmeFeatureFlagGuard],
  data: {
    title: ['mobile_manual_evaluations_navigation_item_label'],
    breadcrumbs: {
      isLinkToPageAvailable: true,
    },
    requiredSecurity: RequiredSecurities.MT_Mobile_Manual_Evaluations_Read,
    [ActivatedRouteData.fmeFeatureFlag]: FeatureFlagName.mobileManualEvaluations,
  },
};
